(function () {
'use strict';
if (window.__slBaseLoaded) return;
window.__slBaseLoaded = true;
var doc = document;
var html = doc.documentElement;
var SL = window.__sl || {};
var CFG = window.__slConfig || {};
var ROUTES = SL.routes || {};
var ROOT = ROUTES.root || '/';
var CART_ADD = (ROUTES.cartAdd || '/cart/add') + '.js';
var CART_CLEAR = (ROUTES.cartClear || '/cart/clear') + '.js';
var IC_MARGIN = Number(CFG.icMarginMs) || 300;
var QTY = Number(CFG.quantity) || 1;
var VARIANTS = SL.variants || [];
function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
function rootPath(path) { return ROOT.replace(/\/$/, '') + '/' + String(path).replace(/^\//, ''); }
function fbqReady() { return typeof window.fbq === 'function'; }
function variantById(id) { for (var i = 0; i < VARIANTS.length; i++) { if (String(VARIANTS[i].id) === String(id)) return VARIANTS[i]; } return null; }
var state = { selected: [], variant: null };
function primaryBox() { return qs('[data-sl-compra][data-primary="true"]') || qs('[data-sl-compra]'); }
function optionCount() { return (SL.options || []).length; }
function matchVariant(sel) {
for (var i = 0; i < VARIANTS.length; i++) {
var v = VARIANTS[i];
var ok = true;
for (var j = 0; j < sel.length; j++) {
if (sel[j] == null) { ok = false; break; }
if (String(v['option' + (j + 1)]) !== String(sel[j])) { ok = false; break; }
}
if (ok) return v;
}
return null;
}
function valueAvailable(optIndex, value, sel) {
for (var i = 0; i < VARIANTS.length; i++) {
var v = VARIANTS[i];
if (!v.available) continue;
if (String(v['option' + (optIndex + 1)]) !== String(value)) continue;
var ok = true;
for (var j = 0; j < sel.length; j++) {
if (j === optIndex || sel[j] == null) continue;
if (String(v['option' + (j + 1)]) !== String(sel[j])) { ok = false; break; }
}
if (ok) return true;
}
return false;
}
function renderOptions(box) {
qsa('[data-sl-option]', box).forEach(function (fs) {
var idx = Number(fs.getAttribute('data-option-index')) - 1;
var label = qs('[data-sl-option-selected]', fs);
if (label) label.textContent = state.selected[idx] != null ? ': ' + state.selected[idx] : '';
qsa('[data-sl-value]', fs).forEach(function (btn) {
var val = btn.getAttribute('data-sl-value');
var on = state.selected[idx] != null && String(state.selected[idx]) === String(val);
btn.setAttribute('aria-pressed', on ? 'true' : 'false');
btn.classList.toggle('is-unavailable', !valueAvailable(idx, val, state.selected));
});
});
}
function minPriceVariant() {
var best = null;
VARIANTS.forEach(function (v) { if (v.available && (!best || v.price < best.price)) best = v; });
return best || VARIANTS[0] || null;
}
function renderPrices() {
var v = state.variant || minPriceVariant();
qsa('[data-sl-compra]').forEach(function (box) {
var price = qs('[data-sl-price]', box), compare = qs('[data-sl-compare]', box), save = qs('[data-sl-save]', box), stock = qs('[data-sl-stock]', box);
if (!v) return;
if (price) price.textContent = v.priceFormatted || '';
if (compare) { compare.textContent = v.compareFormatted || ''; compare.hidden = !v.compareFormatted; }
if (save) {
if (v.compareFormatted && v.compareAt > v.price) {
save.hidden = false;
save.textContent = (box.getAttribute('data-save-text') || 'Ahorras') + ' ' + formatLikePrice(v.compareAt - v.price, v.priceFormatted, v.price);
} else { save.hidden = true; }
}
if (stock) {
var txt = box.getAttribute('data-low-stock-text') || '';
var max = Number(box.getAttribute('data-low-stock-max')) || 5;
if (state.variant && txt && v.tracked && v.inventory > 0 && v.inventory <= max) {
stock.hidden = false; stock.textContent = txt.replace('{n}', v.inventory);
} else { stock.hidden = true; }
}
});
updateSticky(v);
}
function formatLikePrice(amount, sampleFormatted, samplePrice) {
try {
var sample = String(sampleFormatted);
var digits = sample.replace(/[^\d.,]/g, '');
var decimals = /[.,]\d{2}$/.test(digits) ? 2 : 0;
var decSep = decimals ? digits.slice(-3, -2) : '';
var thouSep = decSep === ',' ? '.' : (decSep === '.' ? ',' : (digits.indexOf('.') > -1 ? '.' : (digits.indexOf(',') > -1 ? ',' : '')));
var fixed = amount.toFixed(decimals);
var parts = fixed.split('.');
var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
var num = decimals ? intPart + decSep + parts[1] : intPart;
return sample.replace(digits, num);
} catch (e) { return amount.toFixed(2); }
}
function renderButtons() {
var complete = state.variant != null;
var available = complete && state.variant.available;
qsa('[data-sl-buy]:not([data-variant-id])').forEach(function (btn) {
var box = btn.closest('[data-sl-compra]') || primaryBox();
var choose = (box && box.getAttribute('data-choose-text')) || 'Elige tu talla';
var label = btn.getAttribute('data-label') || btn.textContent;
btn.classList.remove('is-waiting');
btn.disabled = false;
if (!complete && optionCount() > 0) { btn.textContent = choose; btn.classList.add('is-waiting'); }
else if (!available) { btn.textContent = (box && box.getAttribute('data-soldout-text')) || 'Agotado'; btn.disabled = true; }
else { btn.textContent = label; }
});
}
function syncGalleryToVariant() {
if (!state.variant || !state.variant.image) return;
var slide = qs('.sl-gallery__slide[data-media-id="' + state.variant.image + '"]');
var track = slide && slide.closest('.sl-gallery__track');
if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
}
function setSelection(idx, value) {
state.selected[idx] = value;
for (var i = 0; i < optionCount(); i++) if (state.selected[i] === undefined) state.selected[i] = null;
state.variant = matchVariant(state.selected);
qsa('[data-sl-compra]').forEach(renderOptions);
renderPrices();
renderButtons();
syncGalleryToVariant();
doc.dispatchEvent(new CustomEvent('sl:variant-change', { detail: state.variant }));
}
function initSelection() {
var n = optionCount();
state.selected = [];
for (var i = 0; i < n; i++) state.selected.push(null);
var box = primaryBox();
var preselect = !box || box.getAttribute('data-preselect') !== 'false';
if (n === 0) { state.variant = VARIANTS[0] || null; }
else if (preselect) {
var first = null;
VARIANTS.forEach(function (v) { if (!first && v.available) first = v; });
first = first || VARIANTS[0];
if (first) for (var k = 0; k < n; k++) state.selected[k] = first['option' + (k + 1)];
state.variant = matchVariant(state.selected);
} else {
(SL.options || []).forEach(function (opt, k) {
var values = {};
VARIANTS.forEach(function (v) { values[String(v['option' + (k + 1)])] = true; });
var keys = Object.keys(values);
if (keys.length === 1) state.selected[k] = keys[0];
});
state.variant = matchVariant(state.selected);
}
qsa('[data-sl-compra]').forEach(renderOptions);
renderPrices();
renderButtons();
}
doc.addEventListener('click', function (e) {
var val = e.target.closest('[data-sl-value]');
if (val) {
var fs = val.closest('[data-sl-option]');
var idx = Number(fs.getAttribute('data-option-index')) - 1;
var current = state.selected[idx];
setSelection(idx, String(current) === val.getAttribute('data-sl-value') && !val.closest('[data-preselect="true"]') ? null : val.getAttribute('data-sl-value'));
return;
}
var buy = e.target.closest('[data-sl-buy]');
if (buy) { e.preventDefault(); onBuy(buy); return; }
var scroll = e.target.closest('[data-sl-scroll]');
if (scroll) {
var target = qs(scroll.getAttribute('data-sl-scroll'));
if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
}
});
function track(name, data, opts) {
if (!CFG.pixelManual || !fbqReady()) return false;
try { window.fbq('track', name, data, opts || {}); return true; } catch (err) { return false; }
}
function contentsFor(v) {
return { content_ids: [String(v.id)], contents: [{ id: String(v.id), quantity: QTY }], content_type: 'product', content_name: SL.title || '', value: Number(v.price) * QTY, currency: v.currency || SL.currency || '' };
}
function viewContent() {
if (!CFG.pixelManual || !CFG.pixelViewContent || !VARIANTS.length) return;
var fired = false, tries = 0;
var timer = setInterval(function () {
tries += 1;
if (fired || tries > 20) { clearInterval(timer); return; }
if (!fbqReady()) return;
fired = true; clearInterval(timer);
var v = state.variant || minPriceVariant();
track('ViewContent', { content_ids: VARIANTS.map(function (x) { return String(x.id); }), content_type: 'product', content_name: SL.title || '', value: v ? Number(v.price) : 0, currency: SL.currency || '' });
}, 200);
}
var checkingOut = false;
function onBuy(btn) {
if (checkingOut) return;
var direct = btn.getAttribute('data-variant-id');
var v = null;
if (direct) { v = variantById(direct) || { id: direct, price: 0, available: true }; }
else {
v = state.variant;
if (!v) {
var box = (btn.getAttribute('data-sl-buy-target') && qs(btn.getAttribute('data-sl-buy-target'))) || btn.closest('[data-sl-compra]') || primaryBox();
if (box && !qs('[data-sl-option]', box)) box = primaryBox();
var idx = state.selected.indexOf(null);
var fs = box && qsa('[data-sl-option]', box)[idx > -1 ? idx : 0];
(fs || box || btn).scrollIntoView({ behavior: 'smooth', block: 'center' });
if (fs) { fs.classList.add('is-attention'); setTimeout(function () { fs.classList.remove('is-attention'); }, 1500); }
return;
}
if (!v.available) return;
}
startCheckout(v, btn);
}
function setBusy(on, busyText) {
var buttons = qsa('[data-sl-buy]');
buttons.forEach(function (b) {
if (on) { b.__label = b.textContent; b.disabled = true; b.classList.add('is-busy'); b.textContent = busyText || 'Un momento...'; }
else { b.disabled = false; b.classList.remove('is-busy'); if (b.__label) b.textContent = b.__label; }
});
html.classList.toggle('sl-checking-out', on);
checkingOut = on;
}
function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
function fireBeforeJump(v) {
var any = false;
if (CFG.pixelAddToCart) any = track('AddToCart', contentsFor(v)) || any;
if (CFG.pixelInitiateCheckout) {
var eid = 'sl-' + v.id + '-' + Date.now();
any = track('InitiateCheckout', Object.assign(contentsFor(v), { num_items: QTY }), { eventID: eid }) || any;
}
return any ? wait(IC_MARGIN) : Promise.resolve();
}
function permalink(v) { return rootPath('cart/' + v.id + ':' + QTY); }
function customUrl(v) {
var tpl = String(CFG.checkoutUrl || '');
return tpl.replace('{variant_id}', encodeURIComponent(v.id)).replace('{qty}', QTY);
}
function addToCart(v) {
return fetch(CART_CLEAR, { method: 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin' })
.then(function () {
return fetch(CART_ADD, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(v.id), quantity: QTY }] }) });
})
.then(function (res) { if (!res.ok) throw new Error('add-to-cart ' + res.status); return res; });
}
function startCheckout(v, btn) {
setBusy(true, btn && btn.getAttribute('data-busy-text'));
var mode = CFG.checkoutMode || 'checkout';
var flow;
if (mode === 'permalink') {
flow = fireBeforeJump(v).then(function () { window.location.href = permalink(v); });
} else if (mode === 'custom' && CFG.checkoutUrl) {
flow = fireBeforeJump(v).then(function () { window.location.href = customUrl(v); });
} else if (mode === 'cart') {
flow = addToCart(v).then(function () { return fireBeforeJump(v); }).then(function () { window.location.href = rootPath('cart'); });
} else {
flow = addToCart(v).then(function () { return fireBeforeJump(v); }).then(function () { window.location.href = rootPath('checkout'); });
}
flow.catch(function () {
setBusy(false);
window.location.href = permalink(v);
});
}
var sticky = null;
function updateSticky(v) {
if (!sticky) sticky = qs('[data-sl-sticky]');
if (!sticky || !v) return;
var p = qs('[data-sl-sticky-price]', sticky), c = qs('[data-sl-sticky-compare]', sticky);
if (p) p.textContent = v.priceFormatted || '';
if (c) { c.textContent = v.compareFormatted || ''; c.hidden = !v.compareFormatted; }
}
function initSticky() {
sticky = qs('[data-sl-sticky]');
if (!sticky || !('IntersectionObserver' in window)) return;
var targets = qsa('[data-sl-compra] [data-sl-buy]');
if (!targets.length) return;
var visible = new Set();
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
var show = visible.size === 0 && window.scrollY > 200;
sticky.classList.toggle('is-visible', show);
sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
}, { threshold: 0 });
targets.forEach(function (t) { io.observe(t); });
}
function initAccordions() {
qsa('[data-sl-accordion]').forEach(function (acc) {
if (acc.getAttribute('data-single') !== 'true') return;
acc.addEventListener('toggle', function (e) {
var item = e.target;
if (!item.open) return;
qsa('details[open]', acc).forEach(function (d) { if (d !== item) d.open = false; });
}, true);
});
}
function initGalleries() {
qsa('[data-sl-gallery]').forEach(function (g) {
var track = qs('.sl-gallery__track', g);
var slides = qsa('.sl-gallery__slide', g);
var thumbs = qsa('.sl-gallery__thumb', g);
if (!track || slides.length < 2) return;
thumbs.forEach(function (t, i) {
t.addEventListener('click', function () { var s = slides[i]; if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
});
if (!('IntersectionObserver' in window)) return;
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) {
if (!en.isIntersecting) return;
var i = slides.indexOf(en.target);
thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
});
}, { root: track, threshold: 0.6 });
slides.forEach(function (s) { io.observe(s); });
});
}
function init() {
initSelection();
initSticky();
initAccordions();
initGalleries();
viewContent();
}
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
doc.addEventListener('shopify:section:load', function () { sticky = null; initSelection(); initSticky(); initAccordions(); initGalleries(); });
})();

